export async function downloadFile(text: string, filename: string) {
  const saveAs = (await import("file-saver")).saveAs;
  const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
  saveAs(blob, filename);
}

export async function downloadUrl(url: string, filename: string) {
  const saveAs = (await import("file-saver")).saveAs;
  const response = await fetch(url);
  const blob = await response.blob();
  saveAs(blob, filename);
}

export async function downloadTextFile(text: string, filename: string) {
  await downloadFile(text, filename + ".txt");
}

export function sanitizeFilename(filename: string) {
  // Define the regex pattern for unallowable characters
  const pattern = /[<>:"/\\|?*]/g;
  // Replace unallowable characters with an empty string
  const sanitizedFilename = filename.replace(pattern, "");
  return sanitizedFilename;
}
